import React from "react";
import { useMutation } from "@apollo/client";
import { useDispatch, useSelector } from "react-redux";
import { ModalContainer, ModalHeader, ModalContent } from "./Modal";
import { BackstageState } from "../../redux/store";
import styled from "styled-components";
import * as AppActions from "../../redux/actions/app.actions";
import { Button, Colors } from "@sellout/ui";
import { ButtonTypes, ButtonStates } from "@sellout/ui/build/components/Button";
import { media } from "@sellout/ui/build/utils/MediaQuery";
import DELETE_ORGANIZATION from "@sellout/models/.dist/graphql/mutations/deleteSuperAdminOrg.mutation";
import { getErrorMessage } from "@sellout/ui/build/utils/ErrorUtil";
import { AppNotificationTypeEnum } from "../../models/interfaces/IAppNotification";
import history from "../../utils/history";

export const Container = styled.div`
  position: relative;
  width: 700px;
  ${media.tablet`
    width: 100% !important;
  `};
  ${media.mobile`
    width: 100% !important;
  `};
`;

export const RowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 15px;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 15px;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 15px;
  width: 250px;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 15px;
    width: 100%;
  }
`;

type ModalContentHeight = {
  height?: string;
  padding?: string;
  backgroundColor?: string;
};

const ModalFooter = styled.div<ModalContentHeight>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${(props) => (props.padding ? props.padding : "9px 20px")};
  background-color: ${Colors.White};
  border-top: 1px solid ${Colors.Grey6};
  border-radius: 0px 0px 10px 10px;
  justify-content: flex-end;
`;

export enum DeleteOrgModal {
  title = "Delete Organization",
  description = "Are you sure you want to delete this organization?",
  onComplete = "Organization deleted successfully.",
}
export enum ButtonText {
  cancel = "Cancel",
  confirm = "Confirm",
}
const DeleteSuperAdminOrg: React.FC = () => {
  const appState = useSelector((state: BackstageState) => state.app);
  const { modal } = appState;
  const { _id: organizationId } =
    modal?.modalProps?.DeleteSuperAdminOrg[0]?.organization;
  const refetchData = modal?.modalProps?.DeleteSuperAdminOrg[0]?.refetch;
  const setCurrentPage = modal?.modalProps?.DeleteSuperAdminOrg[0]?.setCurrentPage;
  const scrollContainer = modal?.modalProps?.DeleteSuperAdminOrg[0]?.scrollContainer;
  const setHasMore = modal?.modalProps?.DeleteSuperAdminOrg[0]?.setHasMore;

  /* State */

  /* Actions */
  const dispatch = useDispatch();
  const popModal = () => dispatch(AppActions.popModal());

  /* Hooks */
  const [deleteOrg, { loading: deleteLoading }] = useMutation(
    DELETE_ORGANIZATION,
    {
      onError(error) {
        dispatch(
          AppActions.showNotification(
            getErrorMessage(error),
            AppNotificationTypeEnum.Error
          )
        );
      },
      onCompleted() {
        dispatch(AppActions.showNotification(DeleteOrgModal.onComplete, AppNotificationTypeEnum.Success));
        setCurrentPage(1);
        setHasMore(true);
        refetchData();
        if (scrollContainer.current) {
          scrollContainer.current.scrollTop = 0;
        }
        popModal();
      },
    }
  );

  return (
    <>
      <ModalContainer width={"560px"}>
        <ModalHeader title={DeleteOrgModal.title} close={popModal} />
        <ModalContent>
          <Container>{DeleteOrgModal.description}</Container>
        </ModalContent>
        <ModalFooter>
          <div style={{ display: "flex" }}>
            <Button
              type={ButtonTypes.Thin}
              state={ButtonStates.Warning}
              text={ButtonText.cancel}
              margin="0 10px 0 0"
              onClick={() => {
                popModal();
              }}
            />
            <Button
              type={ButtonTypes.Thin}
              text={ButtonText.confirm}
              onClick={() => {
                deleteOrg({
                  variables: {
                    organization: organizationId,
                  },
                });
              }}
              loading={deleteLoading}
            />
          </div>
        </ModalFooter>
      </ModalContainer>
    </>
  );
};
export default DeleteSuperAdminOrg;
